import * as types from '../constants/organization';

/** Update one organization's name and contact details. */
export const apiUpdateOrganization = (token, organizationId, data, userInformationId) => ({
  type: types.API_UPDATE_ORGANIZATION,
  token,
  organizationId,
  data,
  userInformationId,
});
